import { useEffect, useState } from "react";

const SIMS = [
  { label: "Sept 13", target: "2026-09-13T11:30:00-05:00" },
  { label: "Oct 25", target: "2026-10-25T11:30:00-05:00" },
];
const RACE = { label: "Nov 18–22", target: "2026-11-18T08:00:00-06:00" };

const remaining = (t) => new Date(t).getTime() - Date.now();

const units = (ms) => {
  const s = Math.floor(ms / 1000);
  return [
    ["Days", Math.floor(s / 86400)],
    ["Hrs", Math.floor((s % 86400) / 3600)],
    ["Min", Math.floor((s % 3600) / 60)],
    ["Sec", s % 60],
  ];
};

const TimerBlock = ({ title, highlight, ms, testId, accent }) => (
  <div data-testid={testId}>
    <p className="font-mono2 text-[10px] uppercase tracking-[0.3em] text-zinc-400 mb-3">
      {title} — <span className={accent ? "text-volt" : "text-white"}>{highlight}</span>
    </p>
    <div className={`flex gap-px border w-fit ${accent ? "bg-white/10 border-white/10" : "bg-volt/20 border-volt/30"}`}>
      {units(ms).map(([label, val]) => (
        <div key={label} className="bg-[#0c0c0c]/90 backdrop-blur px-4 sm:px-6 py-4 text-center min-w-[68px]" data-testid={`${testId}-${label.toLowerCase()}`}>
          <p className={`font-head font-black text-3xl sm:text-4xl leading-none tabular-nums ${accent ? "text-volt" : "text-white"}`}>
            {String(val).padStart(2, "0")}
          </p>
          <p className="font-mono2 text-[9px] uppercase tracking-[0.25em] text-zinc-500 mt-1">{label}</p>
        </div>
      ))}
    </div>
  </div>
);

export const Countdown = () => {
  const [, tick] = useState(0);

  useEffect(() => {
    const id = setInterval(() => tick((n) => n + 1), 1000);
    return () => clearInterval(id);
  }, []);

  const nextSim = SIMS.find((s) => remaining(s.target) > 0);
  const raceMs = remaining(RACE.target);
  if (!nextSim && raceMs <= 0) return null;

  return (
    <div className="mb-8 flex flex-col sm:flex-row gap-6 sm:gap-10" data-testid="sim-countdown">
      {nextSim && (
        <TimerBlock
          title="Next full simulation"
          highlight={nextSim.label}
          ms={remaining(nextSim.target)}
          testId="countdown-sim"
          accent
        />
      )}
      {raceMs > 0 && (
        <TimerBlock
          title="HYROX Dallas race weekend"
          highlight={RACE.label}
          ms={raceMs}
          testId="countdown-race"
        />
      )}
    </div>
  );
};
